import classNames from 'classnames'
import { type CSSProperties, type RefObject, useRef, type ReactNode } from 'react'
import { NavLink } from 'shared/ui/NavLink'
import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'

interface ITableCellProps {
  minWidth?: string | number
  maxWidth?: string | number
  width?: string | number
  isHeader?: boolean
  isOverflowInitial?: boolean
  className?: string
  style?: CSSProperties
  children: (ref: RefObject<HTMLDivElement>) => ReactNode
  onCellClick?: () => void
  link?: string
  padding?: string | number
  colSpan?: number
  isPointer?: boolean
  ariaLabel?: string
}

export const TableCell = ({
  minWidth,
  maxWidth = '362px',
  width,
  isHeader = false,
  isOverflowInitial,
  className,
  style,
  children,
  onCellClick,
  link,
  padding,
  colSpan,
  isPointer,
  ariaLabel,
}: ITableCellProps) => {
  const refCell = useRef(null)
  const content = (
    <div
      className={classNames(styles.tableCell, className, {
        [styles.headerCell]: isHeader,
        [styles.overflowInitial]: isOverflowInitial,
      })}
      style={{ padding }}
    >
      {children(refCell)}
    </div>
  )

  const Tag = isHeader ? 'th' : 'td'

  return (
    <Tag
      scope={isHeader ? 'col' : undefined}
      className={classNames(styles.cell, { [styles.cellHeader]: isHeader })}
      style={{
        minWidth,
        maxWidth,
        width,
        cursor: isPointer ? 'pointer' : undefined,
        ...style,
      }}
      aria-label={ariaLabel ? getAriaLabel(ariaLabel) : undefined}
      colSpan={colSpan}
      onClick={onCellClick}
      ref={refCell}
    >
      {link ? (
        <NavLink to={link} className={styles.link}>
          {content}
        </NavLink>
      ) : (
        content
      )}
    </Tag>
  )
}
